export interface ITheme {
    background: string; 
    text: string; 
}

export interface IGeneralTheme {
    blue: string;
    orange: string;
    lightBlue: string; 
}

export const darkTheme:ITheme = {
    background: "#000",
    text: "#fff",
}

export const lightTheme:ITheme = {
    background: "#fff",
    text: "#000",
}

export const generalTheme = {
    blue: "#263353",
    orange: "#E76F51",
    lightBlue: "#215FFF",
}